module.exports = {
  Scene3D: {
    PluginName: "3D Object",
    Empty: "No 3D object",
    InteractOn: "Rotate",
    InteractOff: "✓ Rotating on",
    InteractOnHint: "Turn on to rotate and explode the object",
    InteractOffHint: "Turn off to move the box",
  },
};
